"use strict";
/*
 * Created on 03 22 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Jaroslav Sevcik
 */


var PriceStickersDashboardReportDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceStickersDashboardReportDTO, _DomainObject_1$Domai);

  /**
   * DTO used for mini price stickers report on dashboard
   *
   * @param currentWeekRepricingCount a number of new product prices this week
   * @param lastYearSameWeekRepricingCount a number of new product prices the same week last year
   * @param nextWeekRepricingCount a number of new product prices forecasted the for next week
   * @param lastYearNextWeekRepricingCount a number of new product prices last year week after the current one
   */
  function PriceStickersDashboardReportDTO(currentWeekRepricingCount, lastYearSameWeekRepricingCount, nextWeekRepricingCount, lastYearNextWeekRepricingCount) {
    var _this;

    _classCallCheck(this, PriceStickersDashboardReportDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceStickersDashboardReportDTO).call(this));
    _this.currentWeekRepricingCount = currentWeekRepricingCount;
    _this.lastYearSameWeekRepricingCount = lastYearSameWeekRepricingCount;
    _this.nextWeekRepricingCount = nextWeekRepricingCount;
    _this.lastYearNextWeekRepricingCount = lastYearNextWeekRepricingCount;
    return _this;
  }

  return PriceStickersDashboardReportDTO;
}(DomainObject_1.DomainObject);

exports.PriceStickersDashboardReportDTO = PriceStickersDashboardReportDTO;

PriceStickersDashboardReportDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceStickersDashboardReportDTO.name);
  return {
    currentWeekRepricingCount: builder.num('currentWeekRepricingCount'),
    lastYearSameWeekRepricingCount: builder.num('lastYearSameWeekRepricingCount'),
    nextWeekRepricingCount: builder.num('nextWeekRepricingCount'),
    lastYearNextWeekRepricingCount: builder.num('lastYearNextWeekRepricingCount')
  };
}();